import axios from "axios";
import { Base_Url } from "../BaseURL/BaseUrl";

const axiosInstance = axios.create({
  baseURL: Base_Url, // No need for template literal if it's already a string
});
// debugger;
// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // You should ideally retrieve the token from a secure source
    const storedAuth = JSON.parse(localStorage.getItem("login"));
    // const token =
    //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjFkMTJiMTVkLWRmZjAtNDcyYy1hYTk2LWY0YmE4NGZmZDU2NyIsIm5iZiI6MTcyOTc1MDQzOSwiZXhwIjoxNzMwMzU1MjM5LCJpYXQiOjE3Mjk3NTA0Mzl9.6H7CS7Zx9jBDwPvKRC5DZ4aYpAfNfUoINDJzdlbSnJg'; // Example: Get from local storage
    const token = storedAuth.logInItem.token; // Example: Get from local storage

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Handle request errors
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

// Response Interceptor (Optional)
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle response errors
    console.error(
      "Response error:",
      error.response ? error.response.data : error.message
    );
    return Promise.reject(error);
  }
);

export default axiosInstance;
